import React from 'react';
import PropTypes from 'prop-types';

import { useDeriveSubscriptionInfo } from '../../hooks/use-derive-subscription-info';
import { emptyObject } from 'ui-components/default-props/empty';
import { PlanInfoPropType } from '../../../../../prop-types/plan-info';
import TrialActions from './trial-account-actions';
import AccountActions from './account-actions';

const SubscriptionCardActions = ({ reactivatePlan, planInfo = emptyObject }) => {
  const { isSubscriptionExpired, isPlanLocked, billingCycleEndDateTimeUTC } = planInfo;

  const { isTrialAccount, hasActivePaidPlan, inactiveAccount, canReactivateTrial, activeTrialAccount, planWillExpire } =
    useDeriveSubscriptionInfo(planInfo);

  const showTrialActions = isTrialAccount && !hasActivePaidPlan;
  const showAccountActions = hasActivePaidPlan || inactiveAccount || (planWillExpire && !isTrialAccount) || isPlanLocked;

  return (
    <>
      {showTrialActions && (
        <TrialActions activeTrialAccount={activeTrialAccount} canReactivateTrial={canReactivateTrial} reactivatePlan={reactivatePlan} />
      )}
      {showAccountActions && (
        <AccountActions
          billingCycleEndDate={billingCycleEndDateTimeUTC}
          inactiveAccount={inactiveAccount}
          isPlanLocked={isPlanLocked}
          isSubscriptionExpired={isSubscriptionExpired}
        />
      )}
    </>
  );
};

SubscriptionCardActions.propTypes = {
  reactivatePlan: PropTypes.func.isRequired,
  planInfo: PlanInfoPropType,
};

export default SubscriptionCardActions;
